"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M23 0H1C.45 0 0 .45 0 1v15c0 .55.45 1 1 1h12.4l3.72 6.47c.24.46.72.55 1.2.52.48-.03.88-.41.93-.89l.66-6.1H23c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1Zm-3.53 15c-.46 0-.94 0-1.25.4-.23.3-.23.66-.27 1.02-.03.24-.41 4.1-.41 4.1-.36-.68-1.65-3.1-1.94-3.63-.15-.28-.29-.56-.45-.84-.09-.16-.18-.34-.29-.5-.07-.1-.14-.19-.23-.27-.33-.29-.78-.27-1.2-.27H2V2h20v13h-2.53Z"
  })]
});